import React, { useEffect, useRef, useState } from "react";
import { StaffApprovalData } from "./data/CreateGMPCourse.Data";
import { CommitteeCpdApprovalData, CPDEventData } from "./data/CpdEvent.data";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import {useLazyGetAllDropDownsForMemberDirectoryQuery,useLazyGetPDFQuery,useStoreBase64ImageMutation,useUploadPDFMutation,} from "../../app/services/common/commonApi";
import {HideShowChooseEvent,setAllDropDownField,setCpdFieldParameter,setDropDownField,setFieldParameterForCpdStaffCommittee,} from "./utils/setFieldParameter";
import {useCPDCommitteDecisionApproveOrRejectMutation,useCpdStaffDecisionApproveOrRejectMutation,useLazyCPDInternalNotesStaffAndCommitteeQuery,useLazyGetCPDEventByCpdEventIdQuery,useLazyGetCPDEventByCpdEventTypeIdQuery,useLazyGetDropdownForApprovedCPDEventQuery,useUpdateCPDEventMutation,} from "../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import SwalAlert from "../../services/swalService/SwalService";
import { saveAs } from "file-saver";
import moment from "moment";
import { decryptAESID } from "../../utils/Encryption";
import Swal from "sweetalert2";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import RejectReason from "./component/RejectReason";

const EditCpdEventTaskList = (props) => {
  const rejectReasonRef = useRef()
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0;
  const cpdEventRef = useRef();
  const staffApprovalRef = useRef();
  const committeeDecisionRef = useRef();
  const navigate = useNavigate();
  const { error, success } = SwalAlert();
  const [formData, setFromData] = useState(CPDEventData);
  const [commiteeFormData, setCommitteeFromData] = useState(CommitteeCpdApprovalData);
  const [staffFormData, setStaffFromData] = useState(StaffApprovalData);
  const [uploads, setUploads] = useState({
    eventProgramme: null,
    eventProgrammeName: null,
    speakerCvs: null,
    speakerCvsName: null,
  });
  const [isModalOpen, setIsOpenModal] = useState(false)
  const [getAllDropDowns,{isSuccess: isGetAllDropDownFetched,isFetching: isGetDropDownFetching,data: allDropDownResponse,},] = useLazyGetAllDropDownsForMemberDirectoryQuery();
  const [getCPDEventByCpdEventId,{isSuccess: isSuccess,isFetching: isCpdFetching,data: getCpdEventResponse,},] = useLazyGetCPDEventByCpdEventIdQuery();
  const [getPDF] = useLazyGetPDFQuery();
  const [uploadPDF] = useUploadPDFMutation();
  const [saveMainImage] = useStoreBase64ImageMutation();
  const [getDropdownForApprovedCPDEvent,{isSuccess: isGetDropdownForApprovedCPDEventFetched,isFetching: isGetDropdownForApprovedCPDEventFetching,data: getDropdownForApprovedCPDEventData,},] = useLazyGetDropdownForApprovedCPDEventQuery();
  const [updateCPDEvent,{isSuccess: isUpdateCPDEvent,isLoading: isUpdateCPDEventLoading,data: gmpUpdateCPDEventData,},] = useUpdateCPDEventMutation();
  const [cpdStaffDecisionApproveOrReject,{isSuccess: isSuccessStaffDecisionApproveOrReject,isLoading: isFetchingAppStaffDecisionApproveOrReject,data: StaffDecisionApproveOrRejectResponse,},] = useCpdStaffDecisionApproveOrRejectMutation();
  const [internalNotesStaffAndCommittee,{isSuccess: internalNotesStaffAndCommitteeisSuccess,isLoading: internalNotesStaffAndCommitteeisisLoading,data: internalNotesStaffAndCommitteeResponse,},] = useLazyCPDInternalNotesStaffAndCommitteeQuery();
  const [cPDCommitteDecisionApproveOrReject,{isSuccess: isSuccessCommitteDecisionApproveOrReject,isLoading: isFetchingAppCommitteDecisionApproveOrReject,data: CommitteDecisionApproveOrRejectResponse,},] = useCPDCommitteDecisionApproveOrRejectMutation();

  useEffect(() => {
    const fetchData = async () => {
      await getAllDropDowns();
      if (editID) {
        getCPDEventByCpdEventId(editID);
        internalNotesStaffAndCommittee(editID);
      }
    };
    fetchData();
  }, [editID]);

  useEffect(() => {
    if (!isGetDropDownFetching &&isGetAllDropDownFetched &&allDropDownResponse) {
      setAllDropDownField(allDropDownResponse);
    }
  }, [isGetDropDownFetching, isGetAllDropDownFetched, allDropDownResponse]);

  useEffect(() => {
  const initializeForm = async () => {
    if (isSuccess && !isCpdFetching && getCpdEventResponse) {
      const { gmpCourseProviderId, approveCPDEventTypeId } = getCpdEventResponse;
      if (gmpCourseProviderId) {
        try {
          const dropdownData = await getDropdownForApprovedCPDEvent(gmpCourseProviderId).unwrap();
          if (dropdownData) {
            setDropDownField(dropdownData, approveCPDEventTypeId);
          }
        } catch (error) {
          console.error("Failed to load dropdown data:", error);
          return;
        }
      }
      // update field parameters
      setCpdFieldParameter(getCpdEventResponse, "getCpdEventResponse");
      const getUpdatedFormFields = (formData) => {
        return formData.map((field) => {
          const isFileField = ["eventProgrammeFile", "speakersCVSFile"].includes(field.dataField);
          const isStatusApproved = [5, 6].includes(getCpdEventResponse?.statusId);
          const isStatusTwo = getCpdEventResponse?.statusId === 2;
          return {...field,fieldSetting: {...field.fieldSetting,isDisable:isStatusApproved? !isFileField: isStatusTwo && field.dataField === "cpdPoints" ? true : field.fieldSetting?.isDisable || false, },};
        });
      };

      const cpdFormFields = getUpdatedFormFields(CPDEventData.formFields);
      const staffFormFields = getUpdatedFormFields(StaffApprovalData.formFields);
      let committeeFormFields = getUpdatedFormFields(CommitteeCpdApprovalData.formFields);

      if (getCpdEventResponse?.isSendforCommitteeApproval === true) {
        committeeFormFields = committeeFormFields.map((field) => {
          if (field.dataField === "internalComments") {
            return {...field,fieldSetting: {...field.fieldSetting,isDisable: false,},};
          }
          return field;
        });
      }
      setFromData({ ...CPDEventData, formFields: cpdFormFields });
      setStaffFromData({ ...StaffApprovalData, formFields: staffFormFields });
      setCommitteeFromData({...CommitteeCpdApprovalData,formFields: committeeFormFields,});
    }
  };

  initializeForm();
}, [isSuccess, isCpdFetching, getCpdEventResponse]);

  
  useEffect(() => {
    if (!isGetDropdownForApprovedCPDEventFetching &&isGetDropdownForApprovedCPDEventFetched &&getDropdownForApprovedCPDEventData) {
      setDropDownField(getDropdownForApprovedCPDEventData);
    }
  }, [isGetDropdownForApprovedCPDEventFetching,isGetDropdownForApprovedCPDEventFetched,getDropdownForApprovedCPDEventData,]);

  useEffect(() => {
    if (!isUpdateCPDEventLoading && isUpdateCPDEvent && gmpUpdateCPDEventData) {
      success("Your application has been Updated Successfully!");
      getCPDEventByCpdEventId(editID);
    }
  }, [isUpdateCPDEventLoading, isUpdateCPDEvent, gmpUpdateCPDEventData]);

  useEffect(() => {
    if (!isFetchingAppStaffDecisionApproveOrReject &&isSuccessStaffDecisionApproveOrReject &&StaffDecisionApproveOrRejectResponse) {
      if (StaffDecisionApproveOrRejectResponse.errorMessage == "Approved") {
        success("Application Approved Successfully");
      } else if (
        StaffDecisionApproveOrRejectResponse.errorMessage =="Cpd Event Already Reject Or Approved"
      ) {
        error("Cpd Event Already Reject Or Approved");
      } else {
        error("Your Application has been rejected");
        setIsOpenModal(false)
      }
      setTimeout(() => {
        navigate("/gmpTaskList");
      }, 2000);
    }
  }, [isFetchingAppStaffDecisionApproveOrReject,isSuccessStaffDecisionApproveOrReject,StaffDecisionApproveOrRejectResponse,]);

  useEffect(() => {
    if (!internalNotesStaffAndCommitteeisisLoading &&internalNotesStaffAndCommitteeisSuccess &&internalNotesStaffAndCommitteeResponse) {
      setFieldParameterForCpdStaffCommittee(internalNotesStaffAndCommitteeResponse,"internalNotesStaffAndCommitteeResponse");
    }
  }, [internalNotesStaffAndCommitteeisisLoading,internalNotesStaffAndCommitteeisSuccess,internalNotesStaffAndCommitteeResponse,]);

  useEffect(() => {
    if (!isFetchingAppCommitteDecisionApproveOrReject &&isSuccessCommitteDecisionApproveOrReject &&CommitteDecisionApproveOrRejectResponse) {
      if (CommitteDecisionApproveOrRejectResponse.errorMessage == "Approved") {
        success("Application Approved Successfully");
      } else {
        error("Your Application has been rejected");
      }
      setTimeout(() => {
        navigate("/gmpTaskList");
      }, 2000);
    }
  }, [isFetchingAppCommitteDecisionApproveOrReject,isSuccessCommitteDecisionApproveOrReject,CommitteDecisionApproveOrRejectResponse,]);

  const handleSubmit = () => {
    let gmpCpdEventData = cpdEventRef.current.getFormData();
    if (!gmpCpdEventData) {
      error("Please fill all mandatory fields.", "");
      return;
    }

    let request = {
      CpdEventId: editID,
      GMPCourseProviderId: getCpdEventResponse?.gmpCourseProviderId,
      IsApplicationRunNew:gmpCpdEventData?.applicationRun === "New" ? true : false || false,
      ApproveCPDEventTypeId:gmpCpdEventData?.chooseEvent?.value || gmpCpdEventData?.chooseEvent,
      CpdEventTypeId:gmpCpdEventData?.typeOfEvent?.value || gmpCpdEventData?.typeOfEvent,
      CpdEventCompetenciesId:gmpCpdEventData?.eventCompetencies?.join(",") || gmpCpdEventData?.eventCompetencies,
      EventTitle: gmpCpdEventData?.eventTitle || null,
      EventSynopsis: gmpCpdEventData?.eventSynopsis || null,
      EventUrl: gmpCpdEventData?.eventURL || null,
      RegistrationUrlOrEmail:gmpCpdEventData?.registrationURLorEmailAddress || null,
      EventProgramme:uploads?.eventProgramme || getCpdEventResponse?.eventProgramme,
      EventProgremmeFilename:uploads?.eventProgrammeName ||getCpdEventResponse?.eventProgremmeFilename,
      SpeakerCV: uploads?.speakerCvs || getCpdEventResponse?.speakerCV,
      SpeakerCVFilename:uploads?.speakerCvsName || getCpdEventResponse?.eventProgremmeFilenamell,
      AdditionRemarks: gmpCpdEventData?.additionalRemarks || null,
      EventVenue: gmpCpdEventData?.eventVenue || null,
      VenueAddress: gmpCpdEventData?.eventAddress || null,
      PostalCode: gmpCpdEventData?.postalCode || null,
      StandardOrNonMemberFees: gmpCpdEventData?.standardOrNonMember ? parseFloat(String(gmpCpdEventData.standardOrNonMember).replace(/[^0-9.]/g, "")): null,
      MemberFees: gmpCpdEventData?.member? parseFloat(String(gmpCpdEventData.member).replace(/[^0-9.]/g, "")): null,
      NameOfRepresentative: gmpCpdEventData?.nameOfRepresentative || null,
      ContactNumber: gmpCpdEventData?.contactNumber || null,
      EmailAddress: gmpCpdEventData?.emailAddress || null,
      AltNameOfRepresentative:gmpCpdEventData?.nameofAlternateRepresentative || null,
      AltContactNumber: gmpCpdEventData?.alternateContactNumber || null,
      AltEmailAddress: gmpCpdEventData?.alternateEmailAddress || null,
      ScheduleStartDate: gmpCpdEventData?.startDate || null,
      ScheduleEndDate: gmpCpdEventData?.endDate || null,
      ScheduleStartTime: gmpCpdEventData?.startTime ? moment(gmpCpdEventData?.startTime).format("HH:mm") : null,
      ScheduleEndTime: gmpCpdEventData?.endTime ? moment(gmpCpdEventData?.endTime).format("HH:mm"): null,
      TotalContactHours: gmpCpdEventData?.totalContactHours || null,
      CpdPoints: gmpCpdEventData?.cpdPoints || null,
    };
    updateCPDEvent(request);
  };

  const handleOnChangeFileUpload = async (data, storagePath) => {
    let formData = new FormData();
    formData.append("file", data);
    formData.append("storagePath", storagePath);
    try {
      const response = await uploadPDF(formData);
      let tempUploads = { ...uploads };
      switch (storagePath) {
        case "EventProgrammeFile": {
          tempUploads.eventProgramme = response.data.fileName;
          tempUploads.eventProgrammeName = response.data.uploadedFileName;
          break;
        }
        case "SpeakersCVSFile": {
          tempUploads.speakerCvs = response.data.fileName;
          tempUploads.speakerCvsName = response.data.uploadedFileName;
          break;
        }
      }
      setUploads(tempUploads);
    } catch (e) {
      error(e, "Error");
    }
  };

  const handleFormFieldChange = (dataField, value) => {
    if (dataField === "applicationRun" && value === "New") {
      HideShowChooseEvent(value);
      // resetForm()
    } else if (dataField === "eventProgrammeFile" && value) {
      if (value.type === "application/pdf") {
        handleOnChangeFileUpload(value, "EventProgrammeFile");
      } else {
        handleOnChangeImageUpload(value, "EventProgrammeFileImage");
      }
    } else if (dataField === "speakersCVSFile" && value) {
      if (value.type === "application/pdf") {
        handleOnChangeFileUpload(value, "SpeakersCVSFile");
      } else {
        handleOnChangeImageUpload(value, "SpeakersCVSFileImage");
      }
    } else if (dataField === "applicationRun" && value) {
      HideShowChooseEvent(value);
    }
  };

  const handleOnChangeImageUpload = async (data, storagePath) => {
    const { base64Data, fileName } = data;
    let saveFileRequest = {
      fileName: fileName,
      fileStr: base64Data,
      storagePath: storagePath,
    };

    try {
      const response = await saveMainImage(saveFileRequest);
      let tempUploads = { ...uploads };
      switch (storagePath) {
        case "EventProgrammeFileImage": {
          tempUploads.eventProgramme = response.data.fileName;
          tempUploads.eventProgrammeName = response.data.uploadedFileName;
          break;
        }
        case "SpeakersCVSFileImage": {
          tempUploads.speakerCvs = response.data.fileName;
          tempUploads.speakerCvsName = response.data.uploadedFileName;
          break;
        }
      }
      setUploads(tempUploads);
    } catch (error) {
      console.log(error, "error..");
    }
  };

  const handleDownload = async (data, dataField) => {
    let request = {
      type: "",
      fileName: "",
    };
    switch (dataField) {
      case "eventProgrammeFile": {
        request.type = "EventProgrammeFile";
        request.fileName =
          uploads?.eventProgramme || getCpdEventResponse?.eventProgramme;
        break;
      }
      case "speakersCVSFile": {
        request.type = "SpeakersCVSFile";
        request.fileName =
          uploads?.speakerCvs || getCpdEventResponse?.speakerCV;
        break;
      }
    }
    const response = await getPDF(request);
    saveAs(response?.data?.fileData, response?.data?.fileName);
  };

  const handleApprove = () => {
    let staffApprovalrData = staffApprovalRef.current.getFormData();
    let commiteeFormData = committeeDecisionRef.current.getFormData();
    if (staffApprovalrData?.sendforCommitteeApproval == false) {
      if (!commiteeFormData?.finalCpdPoints) {
          error("Please fill Final CPD Point", "")
          return;
      }
  }
    let request = {
      CpdEventId: editID,
      InternalComment: staffApprovalrData?.internalComments || null,
      IsSendforCommitteeApproval: staffApprovalrData?.sendforCommitteeApproval
        ? true
        : false,
      IsReject: false,
      FinalCpdPoints: commiteeFormData?.finalCpdPoints || null,
    };

    if (!staffApprovalrData?.sendforCommitteeApproval) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to approve without sending for committee approval?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#11521c8b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          cpdStaffDecisionApproveOrReject(request);
        }
      });
    } else {
      cpdStaffDecisionApproveOrReject(request);
    }
  };
  
  const handleReject = () => {
    let data = rejectReasonRef?.current?.getFormData();  
    let staffApprovalrData = staffApprovalRef.current.getFormData();
    if(!!data){
    let request = {
      CpdEventId: editID,
      InternalComment: data?.rejectReason || null,
      IsSendforCommitteeApproval: staffApprovalrData?.sendforCommitteeApproval ? true: false,
      IsReject: true,
      FinalCpdPoints: 0,
    };    
    cpdStaffDecisionApproveOrReject(request);
  }
  };

  const handleCommitteApprove = () => {
    let commiteeFormData = committeeDecisionRef.current.getFormData();
    if (!commiteeFormData) {
      error("Please fill all mandatory fields.", "");
      return;
    }
    let request = {
      CpdEventId: editID,
      InternalComment: commiteeFormData?.internalComments || null,
      IsReject: false,
      FinalCpdPoint: commiteeFormData?.finalCpdPoints || null,
    };
    cPDCommitteDecisionApproveOrReject(request);
  };

  const handleCommitteReject = () => {
    let commiteeFormData = committeeDecisionRef.current.getFormData();
    if (!commiteeFormData) {
      error("Please fill all mandatory fields.", "");
      return;
    }
    let request = {
      CpdEventId: editID,
      InternalComment: commiteeFormData?.internalComments || null,
      IsReject: true,
      FinalCpdPoint: commiteeFormData?.finalCpdPoints || null,
    };
    cPDCommitteDecisionApproveOrReject(request);
  };

  const handleBack = () => {
    navigate("/gmpTaskList");
  };

  const formActionHandler = {
    DOWNLOAD: handleDownload,
  };
const handleOpenModal =()=>{
 setIsOpenModal(!isModalOpen)
}

  return (
    <>
      <div className="row form-card">
        {!isGetDropDownFetching && !isCpdFetching && (
          <FormCreator
            ref={cpdEventRef}
            {...formData}
            onFormFieldValueChange={handleFormFieldChange}
            onActionChange={formActionHandler}
          />
        )}
      </div>
      <div className="col-md-12 mb-4 mt-4 d-flex justify-content-end">
        <Buttons
          isDisable={[5, 6].includes(getCpdEventResponse?.statusId) ? true : false}
          buttonText={"Save"}
          buttonTypeClassName="btn success-btn ml-2 mt-0"
          onClick={handleSubmit}
        />
      </div>
      <div>
        <div className="row form-card-active">
          <div className="col-12">
            <FormCreator ref={staffApprovalRef} {...staffFormData} />
          </div>
          <div className="col-md-12 mb-0 mt-0 d-flex justify-content-between">
            <Buttons
              isDisable={
                getCpdEventResponse?.cpdPoints == null || 
                internalNotesStaffAndCommitteeResponse?.sentForCommitteeApproval ===
                  true || [5, 6].includes(getCpdEventResponse?.statusId) 
                  ? true
                  : false
              }
              buttonText={"Reject"}
              buttonTypeClassName="btn red-btn  ml-2 mt-0"
              onClick={handleOpenModal}
            />
            <Buttons
              isDisable={ getCpdEventResponse?.cpdPoints == null || internalNotesStaffAndCommitteeResponse?.sentForCommitteeApproval === true || isFetchingAppStaffDecisionApproveOrReject || [5, 6].includes(getCpdEventResponse?.statusId)? true: false }
              buttonText="Approve"
              buttonTypeClassName="btn success-btn ml-2 mt-0"
              onClick={handleApprove}
              isLoading={isFetchingAppStaffDecisionApproveOrReject}
            />
          </div>
        </div>
        <div className="row form-card-active">
          <div className="col-12 mb-3">
            <FormCreator ref={committeeDecisionRef} {...commiteeFormData} />
          </div>
          <div className="col-md-12 mb-0 mt-0 d-flex justify-content-between">            
            <Buttons
              isDisable={ [5,6].includes(getCpdEventResponse?.statusId) || !getCpdEventResponse?.isSendforCommitteeApproval}
              buttonText={"Reject"}
              buttonTypeClassName="btn red-btn ml-2 mt-0"
              onClick={handleCommitteReject}
            />
            <Buttons
              isDisable={
                isFetchingAppCommitteDecisionApproveOrReject || [5, 6].includes(getCpdEventResponse?.statusId)  || !getCpdEventResponse?.isSendforCommitteeApproval}buttonText={"Approve"}
              buttonTypeClassName="btn success-btn ml-2 mt-0"
              onClick={handleCommitteApprove}
              isLoading={isFetchingAppCommitteDecisionApproveOrReject}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 mb-4 mt-4 d-flex justify-content-start">
        <Buttons
          buttonText={"Back"}
          buttonTypeClassName="btn black-btn ml-2 mt-0"
          onClick={handleBack}
        />
      </div>
       <div className="rejection-reson-modal">
                {isModalOpen && (
                    <CenterModel
                        modelTitle="Rejection Reason"
                        show={"test"}
                        handleClose={handleOpenModal}
                        className="reject-model"
                    // onUpload={props.openCloseRejectModal}
                    >
                        <RejectReason
                            ref={rejectReasonRef}
                            isModalOpen={isModalOpen}
                            openCloseRejectModal={handleOpenModal}
                            isLoading={isFetchingAppStaffDecisionApproveOrReject}
                            handleReject={handleReject}
                            // formActionHandler={formActionHandler}
                        />
                    </CenterModel>
                )}
            </div>
    </>
  );
};

export default EditCpdEventTaskList;
